import { useEffect } from 'react';
import { callBackend } from '../../../utils/api';

export default function useOptimizerPortfolioDropdownBootstrap({
    posSizingLabel,
    setOptimalPortfolioDropdownValues,
    setPosSizingPortfolioId,
}) {
    useEffect(() => {
        let cancelled = false;

        const fetchDropdownValues = async () => {
            try {
                const res = await callBackend('optimal_portfolio', 'GET');
                const dropdownValues = res?.optimal_portfolios || [];
                if (cancelled) {
                    return;
                }
                setOptimalPortfolioDropdownValues(dropdownValues);

                const findId = (p) => (p?.id ?? p?.value);
                const findName = (p) => (p?.name ?? p?.displayText);
                const wiByType = dropdownValues.find((p) => p?.type === 'wi');
                const wiByName = dropdownValues.find((p) => findName(p) === posSizingLabel);
                const wi = wiByType || wiByName || null;
                setPosSizingPortfolioId(wi ? findId(wi) : null);
            } catch (error) {
                console.error('Failed to fetch optimizer portfolio dropdown values:', error);
                if (!cancelled) {
                    setOptimalPortfolioDropdownValues([]);
                    setPosSizingPortfolioId(null);
                }
            }
        };

        void fetchDropdownValues();

        return () => {
            cancelled = true;
        };
    }, [posSizingLabel, setOptimalPortfolioDropdownValues, setPosSizingPortfolioId]);
}
